import { createAppTranslation } from '@fiverr-private/i18n-react';
import copies from '../../copies.json';

const { appTranslate } = createAppTranslation(copies, 'layout_menus');

export { appTranslate as translate };
